module.exports = __webpack_public_path__ + "static/media/visioncontracting.974beb1d.png";